import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const links = [
    { to: '/',            label: 'Inicio' },
    { to: '/casos',       label: 'Casos' },
    { to: '/noticias',    label: 'Noticias' },
    { to: '/quienes-somos', label: 'Quiénes Somos' },
    { to: '/contacto',    label: 'Contacto' },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        {/* Logo */}
        <Link to="/" className="navbar-logo" onClick={() => setOpen(false)}>
          <span className="navbar-logo-icon">🔍</span>
          <span className="navbar-logo-text">
            VuelveACasa <span className="navbar-logo-rd">RD</span>
          </span>
        </Link>

        {/* Desktop links */}
        <ul className="navbar-links">
          {links.map(link => (
            <li key={link.to}>
              <Link
                to={link.to}
                className={`navbar-link ${location.pathname === link.to ? 'navbar-link-active' : ''}`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <Link to="/reportar" className="navbar-cta" onClick={() => setOpen(false)}>
          📋 Reportar Caso
        </Link>

        {/* Hamburger */}
        <button
          className={`navbar-hamburger ${open ? 'navbar-hamburger-open' : ''}`}
          onClick={() => setOpen(!open)}
          aria-label="Menú"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`navbar-mobile ${open ? 'navbar-mobile-open' : ''}`}>
        {links.map(link => (
          <Link
            key={link.to}
            to={link.to}
            className={`navbar-mobile-link ${location.pathname === link.to ? 'navbar-mobile-active' : ''}`}
            onClick={() => setOpen(false)}
          >
            {link.label}
          </Link>
        ))}
        <Link to="/reportar" className="navbar-mobile-cta" onClick={() => setOpen(false)}>
          📋 Reportar Caso
        </Link>
      </div>
    </nav>
  );
}
